import { defineTransform, fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { Nullable } from '@client/core/data/types';
import { parseISO } from '@client/core/utils/date';
import { ActivityLogEvents } from '@client/features/activity-log/types';
import { Project } from '@client/features/project/models/project';
import { DELETED_USER } from '@client/features/user/config';
import { User } from '@client/features/user/models/user';

export class ActivityLog<T = Record<string, any>> {
  constructor(
    public readonly id: number,
    public readonly event: ActivityLogEvents,
    public readonly performedAt: Date,
    public readonly properties: T,
    public readonly performedBy: User,
    public readonly commentCount: number,
    public readonly project: Nullable<Pick<Project, 'name' | 'uuid'>>,
    public readonly commenters: User[],
    public readonly lastCommentAt: Nullable<Date>,
  ) {}
}

defineTransform(ActivityLog, (json: JsonResponse, { nullOr, withDefault }) => {
  return {
    performedAt: parseISO(json.performed_at),
    performedBy: withDefault(json.performed_by, () => fromJson(User, json.performed_by), DELETED_USER),
    commentCount: json.comment_count,
    commenters: json.commenters.map((u) => fromJson(User, u)),
    lastCommentAt: nullOr(json.last_comment_at, () => parseISO(json.last_comment_at)),
  };
});
